import { Component } from '@angular/core';

@Component({
  template: '<p>Authorizing to Spotify...</p>',
})
export class SpotifyCallbackComponent {
}
